import HeaderBase from "components/HeaderBase";
import { Outlet } from "react-router-dom";
import useResponsive from "hooks/useResponsive";
import { useConfigPromp } from "routes/context";

const LayoutBase = () => {
  const { isMinorTablet } = useResponsive();
  const { isActiveHeader, isBlocking } = useConfigPromp();

  const getGridTemplateRows = (): string => {
    if (!isActiveHeader && isMinorTablet) {
      return "1fr";
    } else if (isMinorTablet) {
      return "56px 1fr";
    } else {
      return "72px 1fr";
    }
  };

  const gridTemplateRows = getGridTemplateRows();

  return (
    <div
      className={`grid  h-screen w-screen absolute top-0 ${!isBlocking ? 'overflow-y-hidden': ''}`}
      style={{
        gridTemplateRows,
      }}
    >
      <HeaderBase />
      <Outlet />
    </div>
  );
};

export default LayoutBase;
